import styles from "./SocialSignUpButton.module.css";
import { signIn } from "next-auth/react";
import {
    emailRequiredToggle,
    logNewGoogleAnalyticsEvent,
} from "src/utils/utils";
import { setCookie } from "src/utils/cookies/client";
import {
    FORM_DATA_COOKIE_NAME,
    LANDING_PAGE_URL_COOKIE_NAME,
} from "../../../constants";
import useFeatureFlag from "src/hooks/useFeatureFlag";
import {
    getOfferPageRedirectPath,
    getOfferSlugFromID,
} from "@/components/landing/DynamicForm/formSubmitUtils";
import { Site } from "@/types/sites";
import { LandingPageTemplateResponse, SignInProvider } from "@/types/landing";
import { OfferPageTemplate } from "@/types/offers";
type SocialSignUpButtonProps = ({
    provider,
    site,
    landingPage,
    onOfferPage,
    isMobile,
}: {
    provider: SignInProvider;
    site: Site | null;
    landingPage?: LandingPageTemplateResponse | null;
    offerData?: OfferPageTemplate | null;
    onOfferPage?: boolean;
    isMobile?: boolean;
}) => React.ReactElement;

export const SocialSignUpButton: SocialSignUpButtonProps = ({
    provider,
    site,
    landingPage,
    onOfferPage,
    isMobile,
}) => {
    const disableSocialSignIn = useFeatureFlag("disableSocialSignIn");
    const checkIfFormIsValid = (e: React.FormEvent, provider: string): void => {
        e.preventDefault();

        const form = document.querySelector("form");
        if (form) {
            emailRequiredToggle(form, false);

            if (form.checkValidity()) {
                const formData = new FormData(form);
                setCookie(
                    FORM_DATA_COOKIE_NAME,
                    JSON.stringify(Object.fromEntries(formData.entries()))
                );

                setCookie(LANDING_PAGE_URL_COOKIE_NAME, window.location.href);

                if (window) {


                    logNewGoogleAnalyticsEvent(
                        `${provider}-social-sign-in-start`
                    );
                    /**
                     * ACD-17191: Since clicking one of the social sign in redirects,
                     * console logging it out will we wiped. So instead, a feature
                     * flag has been added so that the redirect is disabled and
                     * the console log can be seen.
                     * Once released, this can be remove at will.
                     */

                    if (disableSocialSignIn) {
                        console.log("dataLayer", window.dataLayer);
                    } else {
                        let offerPageRedirectPath = "";
                        if (onOfferPage) {
                            // If we're on a locked offer page, we just need to come
                            // back to the same offer page after signing in
                            offerPageRedirectPath = window.location.href;
                        } else {
                            const offerData = getOfferSlugFromID(
                                site,
                                landingPage?.data?.attributes?.offer_page_id
                            );
                            offerPageRedirectPath = getOfferPageRedirectPath(
                                site,
                                landingPage ?? undefined,
                                offerData ?? undefined
                            );
                        }

                        
                        const currentHost = `${window.location.protocol}//${window.location.hostname}`;
                        const callbackUrl = `${currentHost}${offerPageRedirectPath}`;
                        
                        console.log(
                            `Signing in with ${provider} and redirecting to ${callbackUrl}`
                        );

                        signIn(provider, {
                            callbackUrl: callbackUrl,
                        });
                    }
                }
            } else {
                (form).reportValidity();
            }
        }
    };

    const defaultButtonText = `Continue with ${
        provider.provider.charAt(0).toUpperCase() +
        provider.provider.slice(1).toLowerCase()
    }`;

    let buttonText = defaultButtonText;

    if (isMobile && provider.buttonTextMobile) {
        buttonText = provider.buttonTextMobile;
    } else if ( !isMobile &&  provider.buttonTextDesktop) {
        buttonText = provider.buttonTextDesktop;
    }

    return (
        <button
            className={`${styles["social-button"]} ${
                styles[provider.provider.toLowerCase() + "-button"]
            }`}
            onClick={(e) => checkIfFormIsValid(e, provider.provider)}
        >
            <span
                className={`${
                    styles[provider.provider.toLowerCase() + "-icon"]
                }`}
            ></span>
            {buttonText}
        </button>
    );
};

export default SocialSignUpButton;
